import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PlusCircle, Eye } from "react-feather";
import DataTable from "../../../../components/common/DataTable";
import { useListStockInsQuery } from "../../stockApi";
import { useCanCreateStockIn } from "../../useStockPermissions";
import { useBranchFilter } from "../../../branchFilter/useBranchFilter";
import { paths } from "../../../../routes/paths";

const StockInList = () => {
  const canCreate = useCanCreateStockIn();
  const navigate = useNavigate();
  const { selectedBranchId } = useBranchFilter();
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [includeDeleted, setIncludeDeleted] = useState(false);

  useEffect(() => {
    const handle = setTimeout(() => setSearch(searchInput.trim()), 400);
    return () => clearTimeout(handle);
  }, [searchInput]);

  const { data, isLoading } = useListStockInsQuery({
    branchId: selectedBranchId ?? undefined,
    search: search || undefined,
    includeDeleted,
    pageSize: 100,
  });

  const columns = [
    {
      title: "Stock-In No",
      dataIndex: "stockInNo",
      render: (value, record) => <Link to={paths.stockInDetail(record.recordGuid)}>{value}</Link>,
    },
    { title: "Branch", dataIndex: "branchCode" },
    { title: "LPO No", dataIndex: "lpoNumber", render: (v) => v || "Direct" },
    { title: "Supplier", dataIndex: "supplierName" },
    { title: "Date", dataIndex: "stockInDate", render: (v) => (v ? new Date(v).toLocaleDateString() : "-") },
    { title: "Total Amount", dataIndex: "totalAmount", render: (v) => Number(v || 0).toFixed(2) },
    {
      title: "Status",
      dataIndex: "isDeleted",
      render: (v) => (v ? <span className="badge badge-linedanger">Deleted</span> : <span className="badge badge-linesuccess">Posted</span>),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <button type="button" className="btn btn-link p-2" title="View" onClick={() => navigate(paths.stockInDetail(record.recordGuid))}>
          <Eye size={16} />
        </button>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Stock-In (GRN)</h4>
              <h6>Goods received against an LPO, or direct/ad-hoc purchase</h6>
            </div>
          </div>
          {canCreate && (
            <div className="page-btn">
              <button type="button" className="btn btn-added" onClick={() => navigate(paths.stockInNew)}>
                <PlusCircle className="me-2" size={16} />
                New Stock-In
              </button>
            </div>
          )}
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top flex-wrap gap-2">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search Stock-In No or Supplier"
                    className="form-control form-control-sm formsearch"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="stockin-include-deleted"
                  checked={includeDeleted}
                  onChange={(e) => setIncludeDeleted(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="stockin-include-deleted">Show deleted</label>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable columns={columns} dataSource={data?.items || []} rowKey="recordGuid" loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockInList;
